import React from 'react'
import type { Icon } from 'shared/utils'

const List = (props: Icon) => {
    const { color = 'white', size = 24, className = 'list' } = props
    return (
        <svg className={className} width={size} height={size}>
            <path
                fill={color}
                fillRule="evenodd"
                d="M5.25 11C4.558 11 4 11.558 4 12.25s.558 1.25 1.25 1.25 1.25-.558 1.25-1.25S5.942 11 5.25 11zm0-5C4.558 6 4 6.558 4 7.25S4.558 8.5 5.25 8.5 6.5 7.942 6.5 7.25 5.942 6 5.25 6zm0 10.142a1.108 1.108 0 1 0-.001 2.215 1.108 1.108 0 0 0 .001-2.215zm2.5 1.941h11.667v-1.666H7.75v1.666zm0-5h11.667v-1.666H7.75v1.666zm0-6.666v1.666h11.667V6.417H7.75z"
            />
        </svg>
    )
}

export { List }
